var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[_vm.groupStyle ? 'state-icon-group' : _vm.groupFeedStyle ? 'state-icon-group-feed' : 'state-icon-content', _vm.noMargin ? 'mt-0' : '']},[_c(_vm.stateIcon,{tag:"component",style:({ color: _vm.color ? '#ff4814' : 'white' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }